import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import logo from '../logo2.png';
import SidebarNav from "./SidebarNav";

const AddEmployee = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('');
    const [salary, setSalary] = useState('');
    const [contact, setContact] = useState(''); // 新增 contact 字段
    const [hireDate, setHireDate] = useState(''); // 新增 hire_date 字段
    const [employeeNumber, setEmployeeNumber] = useState(''); // 新增 employee_number 字段
    const [message, setMessage] = useState('');

    const handleAddEmployee = async (e) => {
        e.preventDefault();

        // 显示确认框，并显示用户输入的信息
        const confirmation = window.confirm(
            `请确认员工信息:\n\n姓名: ${name}\nEmail: ${email}\n公司职位: ${role}\n月薪: ${salary}\n联系方式: ${contact}\n入职日期: ${hireDate}\n员工编号: ${employeeNumber}`
        );

        // 如果用户选择 "Cancel"，则不执行后续代码
        if (!confirmation) {
            return;
        }

        // 如果用户确认，继续添加员工的逻辑
        const { data, error } = await supabase
            .from('employees')
            .insert([{
                name,
                email,
                role,
                salary,
                contact,
                hire_date: hireDate,
                employee_number: employeeNumber
            }]);

        if (error) {
            setMessage(error.message);
        } else {
            setMessage('员工添加成功！');
            setName('');
            setEmail('');
            setRole('');
            setSalary('');
            setContact('');
            setHireDate('');
            setEmployeeNumber('');
        }
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <SidebarNav />

            {/* Main Content */}
            <div className="lg:pl-64">
                <div className="max-w-4xl mx-auto px-4 py-8">
                    {/* Header */}
                    <header className="mb-8">
                        <div className="flex items-center justify-between">
                            <img
                                src={logo}
                                alt="Kindbridge Investments"
                                className="h-12 w-auto"
                            />
                        </div>

                        <h1 className="text-2xl font-semibold text-gray-900">员工管理</h1>
                    </header>

                    {/* Message Display */}
                    {message && (
                        <div
                            className={`mb-6 p-4 rounded-md ${
                                message.includes('成功') ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'
                            }`}
                        >
                            <p className="text-sm">{message}</p>
                        </div>
                    )}

                    {/* Form Card */}
                    <div className="bg-white shadow-sm rounded-lg border border-gray-200 p-6">
                        <form onSubmit={handleAddEmployee} className="space-y-6">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">姓名</label>
                                <input
                                    type="text"
                                    placeholder="姓名"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Email</label>
                                <input
                                    type="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">公司职位</label>
                                <input
                                    type="text"
                                    placeholder="公司职位"
                                    value={role}
                                    onChange={(e) => setRole(e.target.value)}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">月薪</label>
                                <input
                                    type="number"
                                    placeholder="月薪"
                                    value={salary}
                                    onChange={(e) => setSalary(e.target.value)}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">联系方式</label>
                                <input
                                    type="text"
                                    placeholder="联系方式"
                                    value={contact}
                                    onChange={(e) => setContact(e.target.value)}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">入职日期</label>
                                <input
                                    type="date"
                                    placeholder="入职日期"
                                    value={hireDate}
                                    onChange={(e) => setHireDate(e.target.value)}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">员工编号</label>
                                <input
                                    type="text"
                                    placeholder="员工编号"
                                    value={employeeNumber}
                                    onChange={(e) => setEmployeeNumber(e.target.value)}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                    required
                                />
                            </div>
                            <div>
                                <button
                                    type="submit"
                                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                                >
                                    添加
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default AddEmployee;
